import { useCallback, useEffect, useState } from 'react';
import { getWikiPages, reorderWikiPages } from 'api';

export const useWikiPages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setPages(await getWikiPages());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Reorders the siblings of parentId. Applies the new order immediately (optimistic update)
  // and falls back to a full refresh if the server rejects it.
  const reorderPages = useCallback(async (parentId, orderedIds) => {
    const rank = new Map(orderedIds.map((id, index) => [id, index]));
    setPages((prev) => {
      const next = [...prev];
      next.sort((a, b) => (rank.has(a.id) && rank.has(b.id) ? rank.get(a.id) - rank.get(b.id) : 0));
      return next;
    });

    try {
      setPages(await reorderWikiPages(parentId, orderedIds));
    } catch (e) {
      setError(e.message);
      await refresh();
    }
  }, [refresh]);

  return { pages, loading, error, refresh, reorderPages };
};
